let counts: Record<string, number> = {};
let enabled = false;

const enable = (): void => {
  enabled = true;
  counts = {};
};

const disable = (): void => {
  enabled = false;
};

const track = (...strs: string[]): void => {
  if (!enabled) {
    return;
  }
  const id = strs.join('/') ?? '???';

  if (!counts[id]) {
    counts[id] = 0;
  }

  counts[id] += 1;
};

const add = (id: string, amount: number): void => {
  if (!enabled) {
    return;
  }

  if (!counts[id]) {
    counts[id] = 0;
  }

  counts[id] += amount;
};

const getCounts = (): Record<string, number> => counts;

export default {
  add,
  disable,
  enable,
  getCounts,
  track,
};
